import { render, staticRenderFns } from "./LangSelectorMenu.vue?vue&type=template&id=4264f43a&scoped=true"
import script from "./LangSelectorMenu.vue?vue&type=script&lang=js"
export * from "./LangSelectorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264f43a",
  null
  
)

export default component.exports